import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Forms from "../../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../../Componets/Header";
import { create_account } from "../../../../../Controllers/Accounting/Services/chartOfAccountsService";
import forms from "../../../../../Data/Forms/Accounting/ChartOfAccount/forms";
import headers from "../../../../../Data/Forms/Accounting/ChartOfAccount/headers";
import Loadercomponent from "../../../../../Componets/Loader";

const ChartOfAccountsForm = () => {
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [values, setValues] = useState(forms);

  const getformdata = async (data) => {
    console.log("Form data changed:", data);
  };

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      try {
        const accountData = {
          ...data?.data,
          status: 1,
          isReceivable: data?.data?.isReceivable || false,
          isPayable: data?.data?.isPayable || false,
          isContraAccount: data?.data?.isContraAccount || false,
        };

        if (accountData.isContraAccount && !accountData.associatedaccounts) {
          setButtonLoader(false);
          toast.error("Associated Accounts is required when account is Contra");
          return;
        }

        const result = await create_account(accountData);

        if (result?.success) {
          navigate(-1);
          toast.success(result?.message || "Account created successfully");
          setButtonLoader(false);
        } else {
          setButtonLoader(false);
          if (result?.status_code === 403) {
            window.location.href = "/unauthorized";
          } else {
            toast.error(result?.message || "Failed to create account");
          }
        }
      } catch (error) {
        setButtonLoader(false);
        toast.error(error.message || "Failed to create account");
      }
    }
  };

  useEffect(() => {
    setLoader(false);
  }, []);


  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
          getformdata={getformdata}
        ></Forms>
      </Loadercomponent>
    </Header>
  );
};

export default ChartOfAccountsForm;
